import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileCTA } from "./components/MobileCTA";
import { Intro } from "./components/Intro";
import Home from "./pages/Home";
import Struttura from "./pages/Struttura";
import Camere from "./pages/Camere";
import CameraDettaglio from "./pages/CameraDettaglio";
import Servizi from "./pages/Servizi";
import Territorio from "./pages/Territorio";
import Guida from "./pages/Guida";
import ArticoloDettaglio from "./pages/ArticoloDettaglio";
import Faq from "./pages/Faq";
import Contatti from "./pages/Contatti";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
import NotFound from "./pages/NotFound";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LangProvider>
          <ScrollManager />
          <Intro />
          <Header />
          <main id="main-content" className="pb-16 sm:pb-0">
            <Routes>
              {/* English */}
              <Route path="/en" element={<Home />} />
              <Route path="/en/la-struttura" element={<Struttura />} />
              <Route path="/en/camere" element={<Camere />} />
              <Route path="/en/camere/:slug" element={<CameraDettaglio />} />
              <Route path="/en/servizi-e-informazioni" element={<Servizi />} />
              <Route path="/en/il-territorio" element={<Territorio />} />
              <Route path="/en/guida" element={<Guida />} />
              <Route path="/en/guida/:slug" element={<ArticoloDettaglio />} />
              <Route path="/en/faq" element={<Faq />} />
              <Route path="/en/contatti" element={<Contatti />} />
              <Route path="/en/privacy-policy" element={<Privacy />} />
              <Route path="/en/cookie-policy" element={<Cookie />} />
              {/* Italiano */}
              <Route path="/" element={<Home />} />
              <Route path="/la-struttura" element={<Struttura />} />
              <Route path="/camere" element={<Camere />} />
              <Route path="/camere/:slug" element={<CameraDettaglio />} />
              <Route path="/servizi-e-informazioni" element={<Servizi />} />
              <Route path="/il-territorio" element={<Territorio />} />
              <Route path="/guida" element={<Guida />} />
              <Route path="/guida/:slug" element={<ArticoloDettaglio />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/cookie-policy" element={<Cookie />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <MobileCTA />
          <Toaster position="bottom-right" richColors />
        </LangProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
